import { rgba } from 'polished';
import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import { color, container, screen, spacing, zindex } from '../../../theme';

export const StyledHeroSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${spacing('xl')};
  color: ${color('text_white')};
  position: relative;
  justify-content: center;

  @media (min-width: ${screen('md')}) {
    min-height: calc(100vh - ${spacing('xl4')});
  }

  @media (min-height: 1200px) {
    min-height: 1000px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${zindex('heroBg')};
    background-color: ${color('midnight_900')};
  }

  @media (min-width: ${screen('md')}) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(
        147deg,
        ${color('purple_900')} 0%,
        ${rgba('#1e076e', 0.6)} 70%,
        transparent 100%
      );
      mix-blend-mode: hard-light;
      z-index: ${zindex('heroBgGradient')};
    }
  }
`;

export const StyledHeroSectionBg = styled.div<{ bgImage?: string }>`
  @media (min-width: ${screen('md')}) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.2;
    z-index: ${zindex('heroSectionBg')};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${color('emerald_500')};
      mix-blend-mode: darken;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: black;
      mix-blend-mode: lighten;
    }

    div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: ${({ bgImage }) =>
        bgImage
          ? `url('${bgImage}')`
          : `url('${getPublicPath('/images/jobOffer/heroBg.jpg')}')`};
      background-size: cover;
      background-position: center center;
      filter: grayscale(100%);
      z-index: ${zindex('heroSectionBgImg')};
    }
  }
`;

export const StyledHeroContainer = styled.div`
  z-index: ${zindex('heroContent')};
  width: 100%;
  max-width: calc(${container('xl')} + ${spacing('md')} * 2);
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  height: min-content;
  margin-top: ${spacing('lg')};

  @media (min-width: ${screen('md')}) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  @media (min-width: ${screen('lg')}) {
    display: grid;
    grid-template-columns: [company] minmax(19rem, 25rem) [info] 1fr [sliderNav] ${spacing(
        'xl3'
      )};
    column-gap: ${spacing('xl')};
    align-items: start;
    margin-top: ${spacing('xl')};
  }
`;
